'use client';

import React from 'react';
import { ShareButtonProps } from './types';
import { IconCta } from '../Cta/IconCta';
import styles from './ShareButtons.module.scss';
import { classNames } from '../../utils';
import { getCustomEventConfig, ANALYTICS_EVENT_NAMES } from '../../utils/analytics';

export const ShareButtons: React.FC<ShareButtonProps> = ({
  url,
  copy,
  linkedin,
  x,
  isVertical,
  className,
  analyticsConfig,
}) => {
  /**
   * Helper function to generate analytics config for each share platform action
   * Tracks when users select a specific platform to share content
   */
  const getShareActionConfig = (platform: string, label: string) => {
    if (!analyticsConfig) return {};

    return getCustomEventConfig({
      event: ANALYTICS_EVENT_NAMES.SHARE_ACTION,
      module_name: analyticsConfig.moduleName,
      component_family: analyticsConfig.componentFamily || 'share',
      component_type: analyticsConfig.componentType || 'share-buttons',
      item_title: analyticsConfig.itemTitle?.toLowerCase() || 'unknown',
      share_url: url,
      share_platform: platform,
      share_method: label.toLowerCase(),
    });
  };

  return (
    <div className={classNames(styles['share-buttons'], className)}>
      <div
        className={classNames(
          styles['share-buttons__buttons'],
          isVertical && styles['share-buttons__buttons--vertical']
        )}
      >
        {copy && (
          <IconCta
            size="medium"
            icon="link_copy"
            ariaLabel="Copy"
            onClick={() => {
              navigator.clipboard.writeText(url);
            }}
            customAnalyticsProps={analyticsConfig ? getShareActionConfig('copy', 'Copy Link') : {}}
          />
        )}
        {linkedin && (
          <IconCta
            size="medium"
            icon="linkedin"
            ariaLabel="LinkedIn"
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
            customAnalyticsProps={
              analyticsConfig ? getShareActionConfig('linkedin', 'LinkedIn') : {}
            }
          />
        )}
        {x && (
          <IconCta
            size="medium"
            icon="twitter_x"
            ariaLabel="X"
            href={`https://x.com/share?url=${url}`}
            customAnalyticsProps={analyticsConfig ? getShareActionConfig('x', 'X') : {}}
          />
        )}
      </div>
    </div>
  );
};
